import OlInput from './src/input';

/* istanbul ignore next */
OlInput.install = function(Vue) {
    Vue.component(OlInput.name, OlInput);
};

export default OlInput;